/* SKN&B wishlist — app-free, localStorage. Heart toggle + slide-out drawer. */
(function () {
  var KEY = 'sknb_wishlist_v1';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    updateCounts(list);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) { var l = read(); var i = l.indexOf(h); if (i > -1) { l.splice(i, 1); } else { l.push(h); } write(l); return l.indexOf(h) > -1; }
  function updateCounts(list) {
    var c = (list || read()).length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = c; el.toggleAttribute('hidden', c === 0); });
  }

  function getDrawer() { return document.querySelector('wishlist-drawer'); }
  function openDrawer() { var d = getDrawer(); if (d && d.openDrawer) d.openDrawer(); }

  window.SknbWishlist = { read: read, write: write, has: has, toggle: toggle, open: openDrawer };

  /* Open the drawer from any [data-wishlist-open] trigger (e.g. the header heart). */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-wishlist-open]') : null;
    if (t) { e.preventDefault(); openDrawer(); }
  });

  /* Heart toggle — product cards + PDP. */
  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.handle = this.getAttribute('data-handle');
      if (!this.handle) return;
      this.sync();
      this.addEventListener('click', this.onClick.bind(this));
      this._onChange = this.sync.bind(this, undefined);
      document.addEventListener('wishlist:change', this._onChange);
    }
    disconnectedCallback() { document.removeEventListener('wishlist:change', this._onChange); }
    onClick(e) { e.preventDefault(); e.stopPropagation(); this.sync(toggle(this.handle)); }
    sync(active) {
      var on = active === undefined ? has(this.handle) : active;
      this.classList.toggle('is-active', on);
      var b = this.querySelector('button') || this;
      if (b.setAttribute) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }
  if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);

  /* Renders saved products (used inside the drawer). */
  class WishlistList extends HTMLElement {
    connectedCallback() {
      var params = new URLSearchParams(location.search);
      var shared = (params.get('w') || '').split(',').filter(Boolean);
      if (shared.length) { var cur = read(); shared.forEach(function (h) { if (cur.indexOf(h) === -1) cur.push(h); }); write(cur); }
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.shareBtn = this.querySelector('[data-wishlist-share]');
      if (this.shareBtn) this.shareBtn.addEventListener('click', this.share.bind(this));
      this._onChange = this.render.bind(this);
      document.addEventListener('wishlist:change', this._onChange);
      this.render();
    }
    disconnectedCallback() { document.removeEventListener('wishlist:change', this._onChange); }
    share() {
      var url = location.origin + location.pathname + '?w=' + encodeURIComponent(read().join(','));
      if (navigator.share) { navigator.share({ url: url }).catch(function () {}); }
      else if (navigator.clipboard) {
        navigator.clipboard.writeText(url);
        var t = this.shareBtn.textContent; this.shareBtn.textContent = this.shareBtn.getAttribute('data-copied') || 'Kopierad!';
        var self = this; setTimeout(function () { self.shareBtn.textContent = t; }, 1800);
      }
    }
    async render() {
      if (!this.grid) return;
      var list = read();
      this.toggleAttribute('is-empty', list.length === 0);
      if (this.empty) this.empty.toggleAttribute('hidden', list.length !== 0);
      if (this.shareBtn) this.shareBtn.toggleAttribute('hidden', list.length === 0);
      if (list.length === 0) { this.grid.innerHTML = ''; return; }
      var self = this;
      var cards = await Promise.all(list.map(function (h) { return self.card(h); }));
      this.grid.innerHTML = cards.filter(Boolean).join('');
    }
    async card(handle) {
      try {
        var p = await fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; });
        if (!p) return '';
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var imgSrc = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300') : '';
        var wlCur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
        var wlLoc = (window.Shopify && window.Shopify.locale) || 'sv';
        var price;
        try {
          price = new Intl.NumberFormat(wlLoc, { style: 'currency', currency: wlCur, minimumFractionDigits: (p.price % 100 === 0 ? 0 : 2), maximumFractionDigits: 2 }).format(p.price / 100);
        } catch (e) {
          price = (p.price / 100).toLocaleString('sv-SE', { minimumFractionDigits: 0 }) + ' kr';
        }
        var vendor = p.vendor ? '<span class="wl-card__vendor">' + p.vendor + '</span>' : '';
        return '<li class="wl-card">' +
          '<a href="/products/' + handle + '" class="wl-card__media">' + (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="wl-card__info">' + vendor +
          '<a href="/products/' + handle + '" class="wl-card__title">' + p.title + '</a>' +
          '<span class="wl-card__price">' + price + '</span></div>' +
          '<wishlist-button class="wl-card__remove is-active" data-handle="' + handle + '"><button type="button" aria-label="Ta bort">&times;</button></wishlist-button>' +
          '</li>';
      } catch (e) { return ''; }
    }
  }
  if (!customElements.get('wishlist-list')) customElements.define('wishlist-list', WishlistList);

  /* Slide-out drawer. */
  class WishlistDrawer extends HTMLElement {
    connectedCallback() {
      this.setAttribute('aria-hidden', 'true');
      this.addEventListener('click', this.onClick.bind(this));
      this._onKey = function (e) { if (e.key === 'Escape' && this.classList.contains('is-open')) this.closeDrawer(); }.bind(this);
    }
    onClick(e) { if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); this.closeDrawer(); } }
    openDrawer() {
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this._onKey);
      var c = this.querySelector('.wl-drawer__close');
      if (c) c.focus();
    }
    closeDrawer() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this._onKey);
    }
  }
  if (!customElements.get('wishlist-drawer')) customElements.define('wishlist-drawer', WishlistDrawer);

  if (document.readyState !== 'loading') updateCounts();
  else document.addEventListener('DOMContentLoaded', function () { updateCounts(); });
})();
